import { ReactNode, createContext, useContext, useState } from "react";
import DeleteModal from "./DeleteModal";
import { ICity } from "models/city";

interface ICityAlertProps {
  showDelete: (city: ICity) => void;
}

export const CityAlertContext = createContext<ICityAlertProps>(
  {} as ICityAlertProps
);

export const useCityAlertContext = () =>
  useContext<ICityAlertProps>(CityAlertContext);

interface IOpen {
  open: boolean;
  city: ICity | null;
}

export function CityAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    city: null,
  });

  const showDelete = (city: ICity) => setOpenDelete({ open: true, city });
  const handleCloseDelete = () => setOpenDelete({ open: false, city: null });

  return (
    <CityAlertContext.Provider
      value={{
        showDelete,
      }}
    >
      {openDelete.city && (
        <DeleteModal
          open={openDelete.open}
          city={openDelete.city}
          handleClose={handleCloseDelete}
        />
      )}

      {children}
    </CityAlertContext.Provider>
  );
}
